module.exports = {
    MODE_DATE: "date",
    MODE_DATETIME: "datetime",
    MODE_TIME: "time",

    SIZE_SMALL: "sm",
    SIZE_MEDIUM: "md",
    SIZE_LARGE: "lg"
};



// WEBPACK FOOTER //
// ./src/utils/DateTimeField/Constants.js